export default {
  options: 'Opções de importação',
  formatSelection: 'Por favor, para importar o arquivo corretamente, selecione o formato das faturas que irá importar.',
  format: 'Formato',
  preserveId: 'Importar respeitando a série e o número',
  signed: 'Faturas assinadas',
  file: 'Arquivo',
  formatTypes: {
    label: 'Formatos',
    text: '{0}: Excel, XML.'
  },
  maxSize: {
    label: 'Tamanho máximo',
    text: '{0}: 10 Mb'
  },
  accept: 'Aceitar',
  cancel: 'Cancelar',
  errors: {
    400: {
      1000: 'O campo formato é obrigatório'
    }
  },
  correct: 'Correto',
  rejected: 'Rejeitado',
  notTreated: 'Não Tratado'
}